import React from "react";
import PropTypes from "prop-types";
import { DownloadButton } from "components/buttons";

const downloadJson = ({ data, filename }) => {
  const json = JSON.stringify(data, null, 2);
  const bytes = new TextEncoder().encode(json);
  const blob = new Blob([bytes], {
    type: "application/json;charset=utf-8",
  });

  if (window.navigator.msSaveOrOpenBlob) {
    // IE11
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // Rest of the browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.style.display = "none";
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
  }
};

const DownloadJsonButton = ({ data, filename }) => <DownloadButton onClick={() => downloadJson({ data, filename })} />;

DownloadJsonButton.propTypes = {
  /**
   * Objeto de datos que será exportado como JSON.
   */
  data: PropTypes.object.isRequired,

  /**
   * Nombre del fichero de descarga.
   */
  filename: PropTypes.string.isRequired,
};

export default DownloadJsonButton;
